import React from 'react'

import type { NumericFormatProps } from 'react-number-format'
import { NumericFormat } from 'react-number-format'

interface CustomProps {
  onChange: (event: { target: { name: string; value: string } }) => void
  name: string
}

const NumericFormatCustom = React.forwardRef<NumericFormatProps, CustomProps>(function NumericFormatCustom(props, ref) {
  const { onChange, ...other } = props

  return (
    <NumericFormat
      {...other}
      getInputRef={ref}
      onValueChange={values => {
        onChange({
          target: {
            name: props.name,
            value: values.value
          }
        })
      }}
      decimalSeparator=','
      thousandSeparator='.'
      decimalScale={0}
      valueIsNumericString
    />
  )
})

export default NumericFormatCustom
